import React, { ComponentType, forwardRef, useContext } from 'react';
import { getStyleCollectorContext } from './StyleCollectorContext';

interface SsrStyleSheet {
  css: string;
  id: string;
}

export function makeSSRCompatible<T, P>(
  Component: ComponentType<P>,
  ssrStyleSheet: SsrStyleSheet | SsrStyleSheet[]
): ComponentType<P> {
  const SSRContainer = forwardRef<T, P>((props, ref) => {
    const context = useContext(getStyleCollectorContext());

    if (context) {
      const ssrStyleSheetList = Array.isArray(ssrStyleSheet)
        ? ssrStyleSheet
        : [ssrStyleSheet];

      ssrStyleSheetList.forEach(({ css, id }) => {
        context.addStyles(id, css);
      });
    }

    return <Component {...props} ref={ref} />;
  });

  SSRContainer.displayName = Component.displayName;

  return SSRContainer as unknown as ComponentType<P>;
}
